/**
 * Типы статистики диалогов — зеркало бэк-схем роутера stats (S-1).
 * Эндпоинты: /assistants/{id}/stats/overview | /dialogs | /dialogs/{id}/messages
 */

export type StatsPlatform = 'telegram' | 'max' | 'widget' | 'all';
export type StatsPeriod = 'today' | 'week' | 'month' | 'all';

export interface StatsFilters {
  platform: StatsPlatform;
  period: StatsPeriod;
}

/** Точка графика «диалоги по дням». */
export interface DayPoint {
  date: string; // YYYY-MM-DD
  count: number;
}

/** GET /stats/overview — счётчики + ряд для графика. */
export interface StatsOverview {
  total_dialogs: number;
  unique_users: number;
  dialogs_in_period: number;
  period: string;
  platform: string;
  by_day: DayPoint[];
}

/** Элемент списка диалогов (GET /stats/dialogs). */
export interface DialogListItem {
  id: string;
  platform: string;
  user_name: string | null;
  user_external_id: string;
  last_question: string | null;
  messages_count: number;
  created_at: string;
  last_message_at: string | null;
}

export interface DialogListResponse {
  dialogs: DialogListItem[];
  has_more: boolean;
}

/** Сообщение в переписке (GET /stats/dialogs/{id}/messages). */
export interface DialogMessage {
  id: string;
  direction: 'incoming' | 'outgoing';
  content: string;
  created_at: string;
}

export interface DialogMessagesResponse {
  dialog_id: string;
  platform: string;
  user_name: string | null;
  messages: DialogMessage[];
}

/** Человекочитаемые лейблы платформ. */
export const PLATFORM_LABELS: Record<string, string> = {
  telegram: 'Telegram',
  max: 'MAX',
  widget: 'Виджет',
};

export const PLATFORM_OPTIONS = [
  { value: 'all', label: 'Все платформы' },
  { value: 'telegram', label: 'Telegram' },
  { value: 'max', label: 'MAX' },
  { value: 'widget', label: 'Виджет' },
];

export const PERIOD_OPTIONS = [
  { value: 'all', label: 'Всё время' },
  { value: 'today', label: 'Сегодня' },
  { value: 'week', label: 'Неделя' },
  { value: 'month', label: 'Месяц' },
];
